<div class="tw-flex tw-flex-row-reverse tw-justify-end tw-gap-2.5">
  <ng-template #pageActionVCR></ng-template>
</div>
